import { render, staticRenderFns } from "./product-variable.vue?vue&type=template&id=24c1e63b"
import script from "./product-variable.vue?vue&type=script&lang=js"
export * from "./product-variable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackreeve/projects/logshed/wp-content/themes/logshed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c1e63b')) {
      api.createRecord('24c1e63b', component.options)
    } else {
      api.reload('24c1e63b', component.options)
    }
    module.hot.accept("./product-variable.vue?vue&type=template&id=24c1e63b", function () {
      api.rerender('24c1e63b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/product-variable.vue"
export default component.exports